function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 3a2.5 2.5 0 00-5 0h-.833C3.195 3 2 3.896 2 5v9c0 1.104 1.195 2 2.667 2h6.666C12.805 16 14 15.104 14 14V5c0-1.104-1.195-2-2.667-2H10.5zm-3 0H7a1 1 0 012 0H7.5zM12 14V5h-1v3H5V5H4v9h8zM6.5 6.5v-1h3v1h-3z",
  fill: "#858D94"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgComponent;